import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export default () => {
  const { type, showWizard } = useSelector((state: RootState) => state.layoutEditorPage);
  const { isMap, isThemeEditor, showChartWizard } = useSelector((state: RootState) => state.chartEditorPage);
  const typeMap: Record<string, string> = {
    layout: 'Layout',
    table: 'Table'
  };

  const isChart = type === 'chart';
  let editorType = 'Chart';
  let editorOrWizard = 'editor';
  if (isChart && isMap) editorType = 'Map';
  else if (isChart && isThemeEditor) editorType = 'Theme';
  else if (type in typeMap) {
    editorType = typeMap[type];
    if (showWizard) editorOrWizard = 'wizard';
  }
  if (isChart && showChartWizard) editorOrWizard = 'wizard';

  return (
    <div className="text-ev-dark-purple font-bold content-center mt-[15px]">
      {editorType} {editorOrWizard}
    </div>
  );
};
